import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { clientConfig } from '@/config/clientConfig';
import { KeyPair } from '@/shared/lib/secure-json/core/crypto-core/types';

type KeyPairStoreState = {
  keyPair: KeyPair | null;
};

type KeyPairStore = KeyPairStoreState & {
  setKeyPair: (keyPair: KeyPair) => void;
  clear: () => void;
};

export const useKeyPairStore = clientConfig.isExported
  ? create(
      persist<KeyPairStore>(
        (set) => ({
          keyPair: null,
          setKeyPair: (keyPair) => set({ keyPair }),
          clear: () => set({ keyPair: undefined }),
        }),
        {
          name: 'keypair-storage',
          storage: createJSONStorage(() => sessionStorage),
        },
      ),
    )
  : create<KeyPairStore>((set) => ({
      keyPair: null,
      setKeyPair: (keyPair) => set({ keyPair }),
      clear: () => set({ keyPair: undefined }),
    }));
